const blocks = {
  overview: '.communities__overview',
  gallery: '.communities__gallery',
  resources: '.communities__resources',
  complementary: [
    {
      id: 'jump-to-amenities',
      label: 'Amenities',
    },
    {
      id: 'jump-to-reviews',
      label: 'Reviews',
    },
    {
      id: 'jump-to-gallery',
      label: 'Gallery',
    },
    {
      id: 'jump-to-resources',
      label: 'Resources',
    },
  ],
};

export default blocks;
